import { Api, ArrayUtil, Navigation, StringUtil } from "@mcleod/core";
import { CommonDialogs } from "./CommonDialogs";
import { Layout } from "@mcleod/components";

export class HelpLinkLauncher {
  public static showHelpLinks(layouts: Layout[]) {
    const helpLink = layouts?.length > 0 ? layouts[0].helpLinks?.[0] : null;
    if (helpLink == null) return;
    if (helpLink.startsWith("https://") === true || helpLink.startsWith("http://") === true)
      Navigation.navigateTo(helpLink, { newTab: true });
    else {
      //helpLink is assumed to be a video ID, ask the server for a current URL to access that video
      Api.post("video/create-url", { id: helpLink }).then(response => {
        const data = ArrayUtil.isEmptyArray(response?.data) !== true ? response.data[0] : null;
        const url = data?.url;
        if (StringUtil.isEmptyString(url) !== true)
          Navigation.navigateTo(url, { newTab: true });
        else
          CommonDialogs.showDialog("We're sorry, this training video is not accessible at this time.");
      });
    }
  }
}
